var version = {
    "name":      "dativery",
    "buildDateCode": "20261103-110521",
    "buildDate": "Tue Nov 03 2026 11:05:21 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261103-110521",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;